export class PolicyOfStudent{
    id : number;
    studentId : number;
    policyName : string; 
    policyRatio : number;
    policyDate : Date; 
    issuedBy : string;
    note : string;
} 